import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API, WHATSAPP_NUMBER } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await axios.post(`${API}/leads`, { name: email.split("@")[0], phone: "", email, source: "newsletter" });
      toast.success("You're on the list. Welcome to the studio.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="mt-24" style={{ borderTop: "1px solid var(--hairline)" }} data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 grid md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif text-2xl text-[#EDE4D3] mb-3">The Teak Studio</div>
          <p className="text-[#8A8680] text-sm leading-relaxed max-w-xs">Direct from Factory. Crafted for You.</p>
          <div className="mt-6 font-micro text-[#8A8680]">Est. Pitampura, Delhi</div>
          <div className="mt-8">
            <div className="font-micro text-[#8A8680] mb-3">Correspondence</div>
            <p className="text-[#D8D6D1] text-sm mb-4 leading-relaxed max-w-sm">
              Occasional dispatches on new arrivals &amp; the atelier&apos;s process.
            </p>
            <form onSubmit={submit} className="flex gap-3 max-w-sm">
              <input
                data-testid="newsletter-email"
                className="input-teak flex-1"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                required
              />
              <button className="btn-bronze" disabled={busy} data-testid="newsletter-submit">{busy ? "…" : "Join"}</button>
            </form>
          </div>
        </div>

        <div data-testid="footer-shop">
          <div className="font-micro text-[#8A8680] mb-5">Shop</div>
          <ul className="space-y-3 text-[#D8D6D1] text-sm">
            <li><Link to="/category/beds" className="link-underline">Beds</Link></li>
            <li><Link to="/category/sofas-seating" className="link-underline">Sofas &amp; Seating</Link></li>
            <li><Link to="/category/dining-sets" className="link-underline">Dining Sets</Link></li>
            <li><Link to="/category/chairs" className="link-underline">Chairs</Link></li>
            <li><Link to="/category/tables" className="link-underline">Tables</Link></li>
            <li><Link to="/category/wardrobes-storage" className="link-underline">Wardrobes &amp; Storage</Link></li>
            <li><Link to="/category/tv-units" className="link-underline">TV Units &amp; Cabinets</Link></li>
            <li><Link to="/category/bookshelves" className="link-underline">Bookshelves</Link></li>
            <li><Link to="/category/swatches" className="link-underline text-[#B8895C]">Sample Swatches</Link></li>
          </ul>
        </div>

        <div data-testid="footer-quick-links">
          <div className="font-micro text-[#8A8680] mb-5">Quick Links</div>
          <ul className="space-y-3 text-[#D8D6D1] text-sm">
            <li><Link to="/about" className="link-underline">About Us</Link></li>
            <li><Link to="/custom-design" className="link-underline">Customise a Piece</Link></li>
            <li><Link to="/category/swatches" className="link-underline">Order Swatches</Link></li>
            <li><Link to="/login" className="link-underline">Sign in / Guest</Link></li>
            <li><a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" className="link-underline">WhatsApp</a></li>
            <li><a href="https://www.instagram.com/theteakstudio_/" target="_blank" rel="noreferrer" className="link-underline">Instagram</a></li>
          </ul>
        </div>

        <div data-testid="footer-studio">
          <div className="font-micro text-[#8A8680] mb-5">Studio</div>
          <ul className="space-y-3 text-[#D8D6D1] text-sm">
            <li className="text-[#8A8680]">+91 79822 95008</li>
            <li className="text-[#8A8680] break-all">Info.theteakstudio@gmail.com</li>
            <li className="text-[#8A8680]">Pitampura, Delhi</li>
          </ul>
        </div>
      </div>
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-3" style={{ borderTop: "1px solid var(--hairline)" }}>
        <div className="font-micro text-[#8A8680]">© {new Date().getFullYear()} The Teak Studio</div>
        <div className="font-micro text-[#8A8680]">India · INR · Made to Order</div>
      </div>
    </footer>
  );
}
